import React from 'react';
import { packItems } from '../data/content';
import { icons } from '../utils/icons';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-221" data-mp="kv6eq7rr7rsj">
      <div className="mx-auto max-w-6xl" data-id="element-222" data-mp="pv2kabg3nra7">
        <SectionHeading eyebrow="Dentro del kit" title={<>
              ¿Qué incluye tu{' '}
              <span className="text-brand" data-id="element-224" data-mp="b4lhanntgtb7">Kit de Ejecución Directa</span>?
            </>} subtitle="Doce volúmenes de material curricular que cubren el ciclo escolar completo, desde el Lesson Plan para el docente hasta el Student’s Worksheet final." data-id="element-223" data-mp="ptrfc8ax4dhi" />

        <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-225" data-mp="752wrszwqk8w">
          {packItems.map((item, index) => {
          const Icon = icons[item.icon];
          return <Reveal key={item.title} delay={index * 0.04} className="h-full" data-id="element-226" data-mp="3taq774klp66j" data-mpi={index}>
                <li className="flex h-full flex-col rounded-2xl border-2 border-ink bg-white p-7 transition-transform duration-200 ease-out hover:-translate-y-1" data-id="element-227" data-mp="3csuuusy4wioo">
                  <div className="flex items-center justify-between" data-id="element-228" data-mp="3lulxfoxdo9eb">
                    <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-ink text-volt" data-id="element-229" data-mp="3ltsyha4nuo6q">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-230" data-mp="3hr671abwj5a2" />
                    </span>
                    <span className="font-display text-2xl text-ink/10" data-id="element-231" data-mp="2u121gxf5kvgf">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>
                  <h3 className="mt-6 font-display text-xl leading-tight text-ink" data-id="element-232" data-mp="32x1aine6bkwc">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-base leading-relaxed text-ink/70" data-id="element-233" data-mp="2af754yg465pj">
                    {item.text}
                  </p>
                </li>
              </Reveal>;
        })}

          <Reveal delay={0.2} className="h-full" data-id="element-234" data-mp="9dh9z9ejmnmb">
            <li className="flex h-full flex-col justify-center rounded-2xl border-2 border-ink bg-volt p-8" data-id="element-235" data-mp="9cob0ultt2eq">
              <p className="font-display text-sm tracking-[0.14em] text-ink/60" data-id="element-236" data-mp="eahg1kbe7qdf">
                Master Plan
              </p>
              <p className="mt-3 font-display text-4xl leading-none text-ink" data-id="element-237" data-mp="o23zu51sqxrs">
                Todo listo para ejecutar
              </p>
              <p className="mt-4 text-base leading-relaxed text-ink/75" data-id="element-238" data-mp="3mkstsiydebri">
                Sin preparar material, sin traducir consignas y sin improvisar:
                abres el tomo del nivel y entras al aula.
              </p>
            </li>
          </Reveal>
        </ul>
      </div>
    </section>;
}